<!-- https://hodgef.com/simple-keyboard/editor/?d=hodgef/vue-simple-keyboard/tree/master -->
<script lang="ts">
import Keyboard from 'simple-keyboard'
import 'simple-keyboard/build/css/index.css'

export default {
  name: 'SimpleKeyboard',
  props: {
    layout: {
      type: Object,
      required: false
    },
    keyboardClass: {
      default: 'simple-keyboard',
      type: String
    },
    input: {
      type: String
    }
  },
  data: () => ({
    keyboard: null as Keyboard | null
  }),
  mounted() {
    this.keyboard = new Keyboard(this.keyboardClass, {
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      layout: this.layout
    })
  },
  methods: {
    onChange(input: string) {
      this.$emit('onChange', input)
    },
    onKeyPress(button: string) {
      this.$emit('onKeyPress', button)

      if (button === '{shift}' || button === '{lock}') this.handleShift()
    },
    handleShift() {
      let currentLayout = this.keyboard?.options.layoutName
      let shiftToggle = currentLayout === 'default' ? 'shift' : 'default'

      this.keyboard?.setOptions({
        layoutName: shiftToggle
      })
    }
  },
  watch: {
    input(input: string) {
      this.keyboard?.setInput(input)
    },
    layout(newLayout: object) {
      this.keyboard?.setOptions({
        layout: newLayout
      })
    }
  }
}
</script>

<template>
  <div :class="keyboardClass"></div>
</template>
